/**
 * Mobile scroll performance: disable hero parallax (Rellax) on small viewports.
 * Rellax listens to scroll and updates transforms every frame — heavy on phones.
 * Theme setting "Enable parallax" still works on tablet/desktop (750px+).
 */
(function () {
  var MQ = '(max-width: 749px)';

  function teardown() {
    if (!window.matchMedia(MQ).matches) return;

    document.querySelectorAll('parallax-hero').forEach(function (el) {
      try {
        var load = el.rellax;
        if (load && load.rellaxInstance && typeof load.rellaxInstance.destroy === 'function') {
          load.rellaxInstance.destroy();
        }
        if (load) load.rellaxInstance = null;
      } catch (e) {}

      el.querySelectorAll('[data-parallax-img]').forEach(function (node) {
        node.style.transform = '';
        node.style.webkitTransform = '';
      });
    });
  }

  function run() {
    teardown();
    [80, 250, 600, 1200, 2000].forEach(function (ms) {
      setTimeout(teardown, ms);
    });
  }

  if (document.readyState === 'complete') {
    run();
  } else {
    window.addEventListener('load', run);
  }
})();

/**
 * iOS Safari: occasionally leaves data-scroll-locked on <html> while no drawer
 * / search / dialog is actually open — page won't scroll until a tap. We clear
 * it on load, visibility, and on first touch so the first tap restores scroll.
 */
(function () {
  var isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isIOS) return;

  var openUiSelector =
    'header-search-popdown.is-open, dialog[open][data-scroll-lock-required], .drawer.is-open';

  function noModalOpen() {
    return !document.querySelector(openUiSelector);
  }

  function clearStuckScrollLock() {
    if (!document.documentElement.hasAttribute('data-scroll-locked')) return;
    if (!noModalOpen()) return;
    try {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      document.documentElement.removeAttribute('data-scroll-locked');
    } catch (e) {}
  }

  function schedule() {
    clearStuckScrollLock();
    setTimeout(clearStuckScrollLock, 400);
    setTimeout(clearStuckScrollLock, 1200);
    [2400, 3600].forEach(function (ms) {
      setTimeout(clearStuckScrollLock, ms);
    });
  }

  function onFirstTouch() {
    if (!document.documentElement.hasAttribute('data-scroll-locked')) return;
    if (!noModalOpen()) return;
    clearStuckScrollLock();
    document.removeEventListener('touchstart', onFirstTouch, { passive: true });
  }

  window.addEventListener('load', schedule);
  window.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('pageshow', function () {
    setTimeout(clearStuckScrollLock, 0);
    setTimeout(clearStuckScrollLock, 300);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') setTimeout(clearStuckScrollLock, 50);
  });
  document.addEventListener('touchstart', onFirstTouch, { passive: true });
})();
